
import { renderRule as bannerArticles } from './bannerArticles/render';
import { renderRule as code_instagram } from './code-instagram/render';
import { renderRule as code_subscribe } from './code-subscribe/render';
import { renderRule as featuredArticles } from './featuredArticles/render';
import { renderRule as html } from './html/render';
import { renderRule as imagePanel } from './imagePanel/render';
import { renderRule as pageTiles } from './pageTiles/render';
import { renderRule as panel } from './panel/render';
import { renderRule as photoGallery } from './photoGallery/render';
import { renderRule as searchBox } from './searchBox/render';
import { renderRule as selectedArticles } from './selectedArticles/render';
import { renderRule as sharingIcons } from './sharingIcons/render';
import { renderRule as videoPanel } from './videoPanel/render';
export const items = [
  bannerArticles,
  code_instagram,
  code_subscribe,
  featuredArticles,
  html,
  imagePanel,
  pageTiles,
  panel,
  photoGallery,
  searchBox,
  selectedArticles,
  sharingIcons,
  videoPanel,
]